import { render, staticRenderFns } from "./Asma.vue?vue&type=template&id=db1c14fc&"
import script from "./Asma.vue?vue&type=script&lang=js&"
export * from "./Asma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports